module.exports = __webpack_public_path__ + "static/media/appstore.b97b5b3c.svg";